import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { Callout } from "@blueprintjs/core";

const jsErrorNames = [
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError",
];

const ErrorMessage = ({ error }) => {
  const errorRef = useRef(null);

  useEffect(() => {
    if (error) {
      errorRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [error]);

  return (
    <>
      <div ref={errorRef} />
      {error && (
        <motion.div animate={{ opacity: [0, 1] }} style={{ paddingTop: 15 }}>
          <Callout
            intent="danger"
            title={jsErrorNames.includes(error.name) ? "Error" : error.message}
          >
            <p>
              Please try again. If you still have issues, we are here to help so
              don&apos;t hesitate to{" "}
              <a
                href="https://www.nationalvanlines.com/contact-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                contact us
              </a>
              .
            </p>

            {error.errors && (
              <ul>
                {Object.entries(error.errors).map((e) => (
                  <li key={e[0]}>{e[1][0]}</li>
                ))}
              </ul>
            )}
          </Callout>
        </motion.div>
      )}
    </>
  );
};

ErrorMessage.propTypes = {
  error: PropTypes.instanceOf(Error),
};

ErrorMessage.defaultProps = {
  error: null,
};

const mapStateToProps = (state) => ({
  error: state.estimate.error,
});

export default connect(mapStateToProps)(ErrorMessage);
